<template>
    <v-container grid-list-xl fluid>
      <!-- <FabricRangeSelector type="Roller Blind" :value="selectedFabricGroup" v-on:selected-fabric-group="selectedFabricGroup = $event" :v="$v.selectedFabricGroup" :error="$v.selectedFabricGroup.$error"></FabricRangeSelector> -->

      <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

      <CustomizationSelector title="Pelmet Type" :value="item.variations.pelmetType" :options="['FRS', 'Bonded']" v-on:selected-option="item.variations.pelmetType = $event, pelmetTypeChanged($event)" :v="$v.item.variations.pelmetType" :error="$v.item.variations.pelmetType.$error"></CustomizationSelector>

      <CustomizationSelector title="Fitting" :value="item.variations.fitting" :options="['Face', 'Recess']" v-on:selected-option="item.variations.fitting = $event" :v="$v.item.variations.fitting" :error="$v.item.variations.fitting.$error"></CustomizationSelector>

      <CustomizationSelector title="Pelmet Size" :value="item.variations.pelmetSize" :options="pelmetSizeOptions" v-on:selected-option="item.variations.pelmetSize = $event" :v="$v.item.variations.pelmetSize" :error="$v.item.variations.pelmetSize.$error"></CustomizationSelector>

      <CustomizationSelector title="Pelmet Finish" :value="item.variations.pelmetFinish" :options="pelmetFinishOptions" v-on:selected-option="item.variations.pelmetFinish = $event, pelmetFinishChanged($event)" :v="$v.item.variations.pelmetFinish" :error="$v.item.variations.pelmetFinish.$error"></CustomizationSelector>

      <!-- <v-select v-if="['Somfy Sonesse 30 2.0nm'].includes(item.name)" :items="tubes" v-model="item.tubeType" label="Tube Type"></v-select>
      <v-text-field type="number" min="1" v-model="item.quantity" label="Quantity" @input="item.total = item.quantity * item.itemPrice"></v-text-field>
      <v-text-field v-model="item.itemPrice" label="Item Price" readonly></v-text-field>
      <v-text-field v-model="item.total" label="Total" readonly></v-text-field> -->
      <FabricSelector v-if="item.variations.pelmetFinish === 'Fabric Wrapped'" :fabricGroupID="selectedFabricGroup" :value="item.fabric" v-on:selected-fabric="selectedFabric = $event" :v="$v.item.fabric" :error="$v.item.fabric.$error" :pelmetType="item.variations.pelmetType"></FabricSelector>

      <ColorSelector v-if="item.variations.pelmetFinish === 'Fabric Wrapped'" :fabricID="selectedFabric" :value="item.color" v-on:selected-color="item.color = $event" :v="$v.item.color" :error="$v.item.color.$error"></ColorSelector>

      <CustomizationSelector v-if="item.variations.pelmetFinish === 'Metal'" title="Pelmet Colour" :value="item.variations.pelmetColor" :options="pelmetColorOptions" v-on:selected-option="item.variations.pelmetColor = $event" :v="$v.item.variations.pelmetColor" :error="$v.item.variations.pelmetColor.$error"></CustomizationSelector>
      <v-textarea name="notes" label="Item Notes" v-model="item.notes"></v-textarea>
      <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
      <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
      <b>${{ (item.total).toFixed(2) }}</b>
    </v-container>
</template>

<script>
import ItemService from '@/services/ItemService.js'
import CustomizationSelector from '@/components/parts/CustomizationSelector'
import FabricRangeSelector from '@/components/parts/FabricRangeSelector'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import { required, requiredIf } from 'vuelidate/lib/validators'

// const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    CustomizationSelector,
    FabricRangeSelector,
    FabricSelector,
    ColorSelector,
    DimensionSelector
  },
  data () {
    return {
      pelmetSizeOptions: [],
      pelmetColorOptions: [],
      pelmetFinishOptions: [],
      item: {
        type: 'Pelmets',
        fabric: null,
        color: null,
        orderID: null,
        name: null,
        width: null,
        itemPrice: 0,
        total: 0,
        notes: null,
        quantity: 1,
        variations: {
          pelmetType: null,
          fitting: null,
          pelmetSize: null,
          pelmetFinish: null,
          pelmetColor: null
        },
        ordering: 1000
      },
      edit: false,
      readyToSubmitDimension: false,
      selectedFabric: null,
      selectedFabricGroup: '5b3d99a87636707f2336ced3' // Blockout
    }
  },
  validations: {
    item: {
      name: { required },
      width: { required },
      fabric: { required: requiredIf(function () { return this.item.variations.pelmetFabric === 'Fabric Wrapped' }) },
      color: { required: requiredIf(function () { return this.item.variations.pelmetFabric === 'Fabric Wrapped' }) },
      // color: { required },
      variations: {
        pelmetType: { required },
        fitting: { required },
        pelmetSize: { required },
        pelmetFinish: { required },
        pelmetColor: { required: requiredIf(function () { return this.item.variations.pelmetFabric === 'Metal' }) }
      }
    },
    selectedFabricGroup: { required }
  },
  watch: {
    edittingItem (item) {
      this.useEdittingItem(item)
    },
    selectedFabric (val) {
      this.item.fabric = val
      this.getPrice(this.item)
    },
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    }
  },
  mounted () {
    this.useEdittingItem(this.edittingItem)
  },
  methods: {
    setRoom (room) {
      this.item.name = room.name
      this.item.width = room.width
    },
    makeItem (event) {
      this.item.name = event
      this.item.itemPrice = this.accessoriesPrice[event]
      this.item.total = this.item.itemPrice * this.item.quantity
    },
    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.selectedFabric = (item.fabric && item.fabric._id ? item.fabric._id : item.fabric)
          // this.item.variations.pelmetColor = (item.fabric._id ? item.variations.pelmetColor._id : item.variations.pelmetColor)
          this.pelmetTypeChanged(item.variations.pelmetType)
          this.pelmetFinishChanged(item.variations.pelmetFinish)
        }
      } else {
        this.item = {
          orderID: item.orderID,
          type: 'Pelmets',
          name: null,
          width: null,
          itemPrice: 0,
          total: 0,
          quantity: 1,
          variations: {
            pelmetType: null,
            fitting: null,
            pelmetSize: null,
            pelmetFinish: null,
            pelmetColor: null
          },
          ordering: 1000,
          notes: null
        }
        if (item && item._id) {
          this.item._id = item._id
        }
        this.item.orderID = item.orderID
      }
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error) return

      this.edit = false
      if (this.item.variations.pelmetFinish === 'Fabric Wrapped') {
        delete this.item.variations.pelmetColor
      } else {
        delete this.item.fabric
        delete this.item.color
      }
      this.$emit('create-item', this.item)
    },
    pelmetTypeChanged (val) {
      if (val === 'FRS') {
        this.pelmetSizeOptions = ['100mm', '120mm']
        this.pelmetFinishOptions = ['Metal', 'Fabric Wrapped']
      } else if (val === 'Bonded') {
        this.pelmetSizeOptions = ['105mm x 140mm (face)', '40mm x 170mm (recess)', '160mm x 150mm (reg double)', '120mm x 190mm (slim double)']
        this.pelmetFinishOptions = ['Fabric Wrapped']
      }
      this.item.variations.pelmetFinish = null
      this.item.variations.pelmetSize = null
    },
    pelmetFinishChanged (val) {
      if (val === 'Metal') {
        this.pelmetColorOptions = ['White', 'Black', 'Anodised Silver', 'Sandstone']
      } else if (val === 'Fabric Wrapped') {
        this.pelmetColorOptions = ['Balmoral Blockput', 'Barbados', 'Focus', 'Gala', 'Jersey Blockout', 'Kew', 'Mantra Blockout', 'One-Block', 'Positano', 'Qube', 'Sanctuary', 'Serengetty Blockout', 'Solitaire', 'Tusk Blockout', 'Vivid-Block']
      }
      // this.item.fabric = null
      // this.item.color = null
      // this.item.variations.pelmetColor = null
    },
    async getPrice () {
      const response = await ItemService.getPricing(this.item)
      console.log(this.item)
      if (response.data.price) {
        this.item.itemPrice = response.data.itemPrice
        this.item.total = response.data.total
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/Pelmets.vue